import { FetchCrudData } from '../../models';
import { StoresService } from '../../services';
import { ActionType } from './types';

export const getStoresAndDepartments = (filters: FetchCrudData) => ({
  type: ActionType.GET_STORES,
  payload: StoresService.getStoresAndDepartments(filters),
});
export const getMoreStoresAndDepartments = (filters: FetchCrudData) => ({
  type: ActionType.GET_MORE_STORES,
  payload: StoresService.getStoresAndDepartments(filters),
});
export const addStore = store => ({
  type: ActionType.ADD_STORE,
  payload: StoresService.addStore(store),
});
export const editStore = (id, store) => ({
  type: ActionType.EDIT_STORE,
  payload: StoresService.editStore(id, store),
});
export const deleteStore = id => ({
  type: ActionType.DELETE_STORE,
  payload: StoresService.deleteStore(id),
});
export const getStore = (id: string) => ({
  type: ActionType.GET_STORE,
  payload: StoresService.getStore(id),
});
